__turbopack_context__.v({
  "mobileContent": "social-proof-mobile-module-scss-module__dJqzAG__mobileContent",
  "mobileSocialProof": "social-proof-mobile-module-scss-module__dJqzAG__mobileSocialProof",
  "social-proof-header": "social-proof-mobile-module-scss-module__dJqzAG__social-proof-header",
});
